module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/4_50da12003670f528d7944c465c9dacb4.png";